import { PocketPickEntryScreen } from '@/screens/pocketPick/PocketPickEntryScreen'

export default function () {
  return <PocketPickEntryScreen />
}
